"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _I18n = _interopRequireDefault(require("I18n"));

var _getLang2 = _interopRequireDefault(require("I18n/utils/getLang"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _usageTrackerCore = require("usage-tracker-core");

var _storageKeys = require("usage-tracker-core/storageKeys");

var cookieHelper = _interopRequireWildcard(require("./helpers/cookieHelper"));

var _sendBeacon = _interopRequireDefault(require("./helpers/sendBeacon"));

var _reportError = _interopRequireDefault(require("./helpers/reportError"));

var tempStorage = _interopRequireWildcard(require("./containers/tempStorage"));

var hasBeaconSupport = navigator && typeof navigator.sendBeacon === 'function';
var suffix = _enviro.default.getShort() === 'qa' ? 'qa' : '';
var origin = "https://app.hubspot" + suffix + ".com";
var path = '/usage-logging/v1/log/hublytics-multi/no-auth';

var reportNetworkError = function reportNetworkError(err) {
  return (0, _reportError.default)(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};

var getDebug = function getDebug() {
  return _enviro.default.debug(_storageKeys.debugKey);
};

var isLocal = !_enviro.default.deployed();
var isQa = _enviro.default.getShort() === 'qa';
var trackingClient = (0, _usageTrackerCore.createClient)({
  clientName: 'app',
  getDebug: getDebug,
  getEmail: function getEmail() {
    return (0, _userInfo.default)().then(function (_ref) {
      var user = _ref.user;
      return user.email;
    });
  },
  getHubId: function getHubId() {
    return (0, _userInfo.default)().then(function (_ref2) {
      var portal = _ref2.portal;
      return portal.portal_id;
    });
  },
  getHstc: function getHstc() {
    return cookieHelper.get(_storageKeys.hstcKey) || '';
  },
  getLang: function getLang() {
    return _I18n.default.Info.then(_getLang2.default);
  },
  getTempStorage: tempStorage.get,
  setTempStorage: tempStorage.set,
  logError: function logError(err) {
    if (isLocal || isQa || getDebug()) {
      console.error(err);
    }
  },
  reportError: _reportError.default,
  send: function send(_ref3) {
    var events = _ref3.events,
        query = _ref3.query,
        isAuthed = _ref3.isAuthed,
        isBeforeUnload = _ref3.isBeforeUnload;
    var endpoint = path + "?" + query;
    var data = events;

    var sendXhr = function sendXhr() {
      var promise;

      if (isAuthed) {
        promise = _apiClient.default.post(endpoint, {
          data: data
        }).catch(reportNetworkError);
      } else {
        promise = _noAuthApiClient.default.post(endpoint, {
          data: data
        }).catch(reportNetworkError);
      }

      if (promise && typeof promise.done === 'function') {
        promise.done();
      }
    };

    if (isBeforeUnload && hasBeaconSupport) {
      (0, _sendBeacon.default)("" + origin + endpoint, data, sendXhr);
    } else {
      sendXhr();
    }
  }
});
var _default = trackingClient;
exports.default = _default;
module.exports = exports.default;